import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ConsentService } from '../../services/consent.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private readonly consent = inject(ConsentService);
  readonly year = new Date().getFullYear();

  /** Öffnet das Cookie-Banner erneut (Widerruf/Änderung der Einwilligung). */
  onCookieSettings(): void {
    this.consent.reopen();
  }
}
